import template from './adpDonutChart.html';
import controller from './adpDonutChart.controller';
import './adpDonutChart.less';

let adpDonutChartComponent = {
  restrict: 'E',
  bindings: {
  	data: '<'
  },
  template,
  controller
};

export default adpDonutChartComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpDonutChart/adpDonutChart.component.js